import { createContext, useContext, useState } from "react";

const UtilityContext = createContext();

export const UtilitiesProvider = ({ children }) => {
  // web slider states
  const [AddSliderImages, setAddSliderImages] = useState([]);
  const [AddSliderBinaryImages, setAddSliderBinaryImages] = useState([]);

  // mobile slider states
  const [AddMobileSliderImages, setAddMobileSliderImages] = useState([]);
  const [AddMobileSliderBinaryImages, setAddMobileSliderBinaryImages] =
    useState([]);

  return (
    <UtilityContext.Provider
      value={{
        AddSliderImages,
        setAddSliderImages,
        AddSliderBinaryImages,
        setAddSliderBinaryImages,
        AddMobileSliderImages,
        setAddMobileSliderImages,
        AddMobileSliderBinaryImages,
        setAddMobileSliderBinaryImages,
      }}
    >
      {children}
    </UtilityContext.Provider>
  );
};

export const useUtilitiesContext = () => {
  return useContext(UtilityContext);
};
